export const PROJECT_ROUTES = {
  OVERVIEW: '/project/overview/' as const,
};
